import dateFormat from 'dateformat';
import i18n from './i18n';

export function getParams(query) {
  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      const [key, value] = param.split('=');
      const newParams = params;
      newParams[key] = value
        ? decodeURIComponent(value.replace(/\+/g, ' '))
        : '';
      return newParams;
    }, {});
}

export function formatDateForSessionCard(time, date) {
  const [year, month, day] = date.split('-');
  const [hoursPart, minutesPart] = time.split(':');

  const checkedDate = new Date(year, month - 1, day, hoursPart, minutesPart, 0);
  const todaysDate = new Date();
  const tomorrowsDate = new Date(todaysDate.getTime() + 24 * 60 * 60 * 1000);

  const hour = dateFormat(checkedDate, 'h');
  let minutes = dateFormat(checkedDate, 'MM');
  minutes = minutes !== '00' ? `:${minutes}` : '';

  const amOrPm = dateFormat(checkedDate, 'TT');

  let displayedDate = date;

  if (checkedDate.setHours(0, 0, 0, 0) === todaysDate.setHours(0, 0, 0, 0)) {
    displayedDate = i18n.t('singleSessionScreen.TODAY');
  } else if (
    checkedDate.setHours(0, 0, 0, 0) === tomorrowsDate.setHours(0, 0, 0, 0)
  ) {
    displayedDate = i18n.t('singleSessionScreen.TOMORROW');
  } else {
    displayedDate = dateFormat(checkedDate, '- dd mmmm yyyy');
  }

  return `${hour}${minutes}${amOrPm} ${displayedDate}`;
}

export function scrollScreenToTop() {
  window.scrollTo(0, 0);
}

export function copyListWithNewObject(
  list,
  newObject,
  shouldReplaceObjPredicate
) {
  return list.map(object => {
    if (shouldReplaceObjPredicate(object)) {
      return newObject;
    }
    return object;
  });
}

export function validateEmail(email) {
  const re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function parseFilters(filters) {
  const parsedFilters = [];

  filters.forEach(filter => {
    const filterValues = [];

    filter.values.forEach(singleValue => {
      if (typeof singleValue === 'string') {
        filterValues.push({
          value: singleValue,
          type_name: filter.type_name
        });
      } else {
        filterValues.push({
          value: singleValue.value,
          type_name: filter.type_name
        });
        if (singleValue.subtypes !== undefined) {
          singleValue.subtypes.forEach(subtype =>
            filterValues.push(
              ...subtype.values.map(value => ({
                value,
                type_name: subtype.type_name,
                sub: 1
              }))
            )
          );
        }
      }
    });

    parsedFilters.push({
      name: filter.name,
      values: filterValues,
      selected: []
    });
  });

  return parsedFilters;
}

export function getNumberWithSuffix(number) {
  const ones = number % 10;
  const tens = number % 100;
  if (ones === 1 && tens !== 11) {
    return `${number}st`;
  }
  if (ones === 2 && tens !== 12) {
    return `${number}nd`;
  }
  if (ones === 3 && tens !== 13) {
    return `${number}rd`;
  }
  return `${number}th`;
}



// WEBPACK FOOTER //
// ./src/utils/other.js